export default __webpack_public_path__ + "static/7-0770117d5d6d349e04063236d3fe0053.png";